export const WebsocketEvents = {
  Claim: {
    Created: 'claim.created',
    Updated: 'claim.updated',
    StateUpdated: 'claim.state.updated',
    Assigned: 'claim.assigned',
    DocumentGenerated: 'claim.document.generated',
    AutomationCreated: 'claim.automation.created',
    AutomationStatus: 'claim.automation.status',
    AutomationLifecycle: 'claim.automation.lifecycle',
  },
  Order: {
    Created: 'order.created',
    Updated: 'order.updated',
    Reship: {
      Created: 'order.reship.created',
    },
    Note: {
      Created: 'order.note.created',
      Sync: 'order.note.sync',
      MediaSync: 'order.note.media.sync',
    },
  },
  OrderItem: {
    Created: 'order-item.created',
  },
  Message: {
    Created: 'message.created',
  },
  StoreCredit: {
    Created: 'store-credit.created',
  },
  Notification: {
    Created: 'notification.created',
  },
  Product: {
    SyncCompleted: 'product.sync.completed',
    WarrantySyncCompleted: 'product.warranty.sync.completed',
  },
  Sop: {
    Generated: 'sop.generated',
  },
};
